import React, { FC } from 'react';
import { useApiLocalization } from '~/hooks/useApiLocalization';
import { TextField } from '.';
import { Skeleton } from '@material-ui/lab';

interface ApiLocalizedTextFieldProps {
  label: string;
  keyPrefix: string;
  secondKey?: string;
  fallbackValue?: string;
  isLoading?: boolean;
}

const ApiLocalizedTextField: FC<ApiLocalizedTextFieldProps> = (props) => {
  const { keyPrefix, secondKey, label, fallbackValue, isLoading } = props;
  const enabled = !!keyPrefix && !!secondKey;
  const { data: translations, isLoading: translationsLoading } = useApiLocalization(
    `${keyPrefix}`,
    enabled
  );
  const translationValue = translations && translations[`${keyPrefix}.${secondKey}`];
  return (
    <TextField label={label}>
      {isLoading || translationsLoading ? (
        <Skeleton width={200} />
      ) : translationValue ? (
        translationValue
      ) : (
        secondKey ?? fallbackValue
      )}
    </TextField>
  );
};

export default ApiLocalizedTextField;
